import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import BusinessIcon from '@mui/icons-material/Business';
import GitHubIcon from '@mui/icons-material/GitHub';

const StyledFooter = styled(Box)(({ theme }) => ({
  backgroundColor: '#1a1a1a',
  color: '#b0b0b0',
  borderTop: '1px solid #2a2a2a',
  marginTop: 'auto',
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#b0b0b0',
  textDecoration: 'none',
  fontSize: '0.8125rem',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  '&:hover': {
    color: '#ffffff',
    textDecoration: 'none',
  },
}));

const Brand = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: '0.8125rem',
  color: '#b0b0b0',
}));

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <StyledFooter component="footer">
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1.5, sm: 2 }}
          alignItems="center"
          justifyContent="space-between"
          sx={{ py: 1.5 }}
        >
          <Brand>
            <BusinessIcon sx={{ fontSize: '1rem', color: 'primary.main' }} />
            <Typography component="span" sx={{ fontSize: '0.8125rem', color: '#b0b0b0' }}>
              © {currentYear} PlanningSync
            </Typography>
          </Brand>

          <Stack
            direction="row"
            spacing={2.5}
            alignItems="center"
            flexWrap="wrap"
            justifyContent="center"
          >
            <FooterLink href="#help">Help</FooterLink>
            <FooterLink href="#status">Status</FooterLink>
            <FooterLink href="#privacy">Privacy</FooterLink>
            <FooterLink href="#terms">Terms</FooterLink>
            <FooterLink href="https://github.com" target="_blank" rel="noopener noreferrer">
              <GitHubIcon sx={{ fontSize: '1rem' }} />
            </FooterLink>
          </Stack>
        </Stack>
      </Container>
    </StyledFooter>
  );
};

export default Footer;
